import React, { Component } from "react";
import { IPropsIcone } from "../../modelo/Icone";

class IconeSemMinuta extends Component<IPropsIcone> {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" style={{ fill: this.props.color || 'currentColor' }}>
                <path id="Sem nome" strokeWidth='1'
                    d="M 10.00,2.04
           C 10.00,2.04 3.93,2.02 3.93,2.02
             3.93,2.02 4.00,4.96 4.00,4.96
             4.00,4.96 4.96,4.98 4.96,4.98
             4.96,4.98 5.02,3.96 5.02,3.96
             5.02,3.96 5.96,4.02 5.96,4.02
             5.96,4.02 5.96,3.00 5.96,3.00
             5.96,3.00 7.02,2.98 7.02,2.98
             7.02,2.98 7.02,4.00 7.02,4.00
             7.02,4.00 8.07,4.02 8.07,4.02
             8.07,4.02 8.02,3.02 8.02,3.02
             8.02,3.02 8.98,2.93 8.98,2.93
             8.98,2.93 8.98,4.04 8.98,4.04
             8.98,4.04 8.02,4.09 8.02,4.09
             8.02,4.09 8.07,5.00 8.07,5.00
             8.07,5.00 8.98,4.98 8.98,4.98
             8.98,4.98 8.96,6.02 8.96,6.02
             8.96,6.02 9.91,5.96 9.91,5.96
             9.91,5.96 10.07,6.89 10.07,6.89
             10.07,6.89 10.91,6.96 10.91,6.96
             10.91,6.96 10.98,7.98 10.98,7.98
             10.98,7.98 11.96,8.00 11.96,8.00
             11.96,8.00 11.98,5.98 11.98,5.98
             11.98,5.98 11.07,5.93 11.07,5.93
             11.07,5.93 11.04,4.96 11.04,4.96
             11.04,4.96 9.98,4.96 9.98,4.96
             9.98,4.96 9.96,2.00 9.96,2.00M 2.07,6.02
           C 2.07,6.02 2.02,11.98 2.02,11.98
             2.02,11.98 7.96,12.04 7.96,12.04
             7.96,12.04 7.96,11.00 7.96,11.00
             7.96,11.00 7.04,10.98 7.04,10.98
             7.04,10.98 7.02,10.00 7.02,10.00
             7.02,10.00 6.04,10.02 6.04,10.02
             6.04,10.02 5.98,8.98 5.98,8.98
             5.98,8.98 5.04,9.04 5.04,9.04
             5.04,9.04 5.04,8.00 5.04,8.00
             5.04,8.00 4.02,7.96 4.02,7.96
             4.02,7.96 4.02,9.02 4.02,9.02M 5.09,10.07
           C 5.09,10.07 3.00,9.96 3.00,9.96
             3.00,9.96 2.98,8.00 2.98,8.00
             2.98,8.00 3.87,8.02 3.87,8.02
             3.87,8.02 4.09,7.07 4.09,7.07
             4.09,7.07 3.18,6.91 3.18,6.91
             3.18,6.91 2.98,6.11 2.98,6.11
             2.98,6.11 2.11,6.00 2.11,6.00M 9.00,12.93
           C 9.00,12.93 8.87,13.93 8.93,13.93
             9.00,13.93 8.04,14.00 8.04,14.00
             8.04,14.00 7.96,16.00 7.96,16.00
             7.96,16.00 7.11,15.91 7.11,15.91
             7.11,15.91 6.98,18.96 6.98,18.96
             6.98,18.96 5.98,19.04 5.98,19.04
             5.98,19.04 6.00,20.98 6.00,20.98
             6.00,20.98 6.96,21.02 6.96,21.02
             6.96,21.02 7.00,21.96 7.00,21.96
             7.00,21.96 14.00,21.96 13.98,21.96
             13.96,21.96 14.02,21.11 14.02,21.11
             14.02,21.11 15.02,20.98 15.02,20.98
             15.02,20.98 15.04,18.04 15.04,18.04
             15.04,18.04 14.11,18.04 14.11,18.04
             14.11,18.04 13.93,18.00 13.93,18.00
             13.93,18.00 13.98,17.02 13.98,17.02
             13.98,17.02 13.04,16.96 13.04,16.96
             13.04,16.96 13.07,15.96 13.07,15.96
             13.07,15.96 12.09,16.07 12.09,16.07
             12.09,16.07 11.98,15.89 11.98,15.89
             11.98,15.89 12.02,15.11 12.02,15.11
             12.02,15.11 10.96,15.02 10.96,15.02
             10.96,15.02 11.09,16.02 11.09,16.02
             11.09,16.02 12.07,15.93 12.07,15.93
             12.07,15.93 12.04,16.22 12.04,16.22
             12.04,16.22 12.07,17.96 12.07,17.96
             12.07,17.96 13.76,17.96 13.76,17.96
             13.76,17.96 14.09,18.18 14.09,18.18
             14.09,18.18 14.07,19.02 14.07,19.02
             14.07,19.02 12.98,19.07 12.98,19.07
             12.98,19.07 13.07,19.98 13.07,19.98
             13.07,19.98 11.07,20.02 11.07,20.02
             11.07,20.02 10.96,21.09 10.96,21.09
             10.96,21.09 9.04,21.04 9.04,21.04
             9.04,21.04 8.96,20.04 8.96,20.04
             8.96,20.04 8.07,20.00 8.07,20.00
             8.07,20.00 7.89,17.11 7.89,17.11
             7.89,17.11 9.02,16.98 9.02,16.98
             9.02,16.98 8.96,18.04 8.96,18.04
             8.96,18.04 9.98,18.13 9.98,18.13
             9.98,18.13 10.04,18.98 10.04,18.98
             10.04,18.98 11.91,18.96 11.91,18.96
             11.91,18.96 11.98,18.09 11.98,18.09
             11.98,18.09 10.07,17.89 10.07,17.89
             10.07,17.89 10.02,17.02 10.02,17.02
             10.02,17.02 9.16,16.84 9.16,16.84
             9.16,16.84 9.09,15.13 9.09,15.13
             9.09,15.13 10.84,15.02 10.84,15.02
             10.84,15.02 11.00,13.93 11.00,13.93
             11.00,13.93 10.07,14.02 10.07,14.02
             10.07,14.02 10.09,13.00 10.09,13.00
             10.09,13.00 9.00,13.00 9.00,13.00M 14.04,10.04
           C 14.04,10.04 14.02,10.96 14.02,10.96
             14.02,10.96 14.93,10.98 14.93,10.98
             14.93,10.98 15.04,11.93 15.02,11.93
             15.00,11.93 15.96,11.98 15.96,11.98
             15.96,11.98 16.00,13.02 16.00,13.02
             16.00,13.02 17.02,13.04 17.02,13.04
             17.02,13.04 17.00,12.02 17.00,12.02
             17.00,12.02 16.11,11.98 16.09,11.98
             16.07,11.98 15.93,11.04 15.93,11.04
             15.93,11.04 15.20,10.84 15.20,10.84
             15.20,10.84 15.07,9.96 15.07,9.96
             15.07,9.96 14.00,10.07 14.00,10.07M 17.00,6.98
           C 17.00,6.98 16.96,7.93 16.96,7.93
             16.96,7.93 18.00,8.13 18.00,8.13
             18.00,8.13 18.04,9.11 18.04,9.11
             18.04,9.11 19.00,9.11 19.00,9.11
             19.00,9.11 18.98,10.02 18.98,10.02
             18.98,10.02 20.13,10.04 20.13,10.04
             20.13,10.04 20.13,7.96 20.13,7.96
             20.13,7.96 19.02,8.02 19.02,8.02
             19.02,8.02 18.98,7.04 18.98,7.04
             18.98,7.04 16.96,7.04 16.96,7.04M 15.04,8.00
           C 15.04,8.00 15.02,10.00 15.02,10.02
             15.02,10.04 15.96,9.98 15.96,9.98
             15.96,9.98 16.07,11.04 16.02,11.04
             15.98,11.04 16.91,11.09 16.91,11.09
             16.91,11.09 17.00,12.11 17.00,12.11
             17.00,12.11 18.00,12.13 18.00,12.13
             18.00,12.13 18.00,13.02 18.00,13.02
             18.00,13.02 18.93,13.07 18.93,13.07
             18.93,13.07 18.98,13.96 18.98,13.96
             18.98,13.96 19.98,14.09 19.98,14.09
             19.98,14.09 19.91,15.16 19.91,15.16
             19.91,15.16 22.00,15.02 22.00,15.02
             22.00,15.02 22.02,13.02 22.02,13.02
             22.02,13.02 20.98,13.07 20.98,13.07
             20.98,13.07 20.93,12.22 20.98,12.16
             21.02,12.09 20.07,11.93 20.07,11.93
             20.07,11.93 19.91,10.93 19.91,10.93
             19.91,10.93 19.09,10.98 19.09,10.98
             19.09,10.98 19.00,10.00 19.00,10.00
             19.00,10.00 18.04,9.98 18.04,9.98
             18.04,9.98 18.00,9.11 18.00,9.11
             18.00,9.11 17.11,8.93 17.11,8.93
             17.11,8.93 16.87,8.07 16.87,8.07
             16.87,8.07 15.09,8.00 15.09,8.00" />
            </svg>
        );
    }
}

export default IconeSemMinuta;